import React from "react";

function Music() {

  const music = [
    {
      id: 1,
      speaker: "MRINMAY ",
      designation: "Singer-Songwriter",
      src:'https://res.cloudinary.com/dkqxnquga/image/upload/v1693981090/274954844_476365647296622_2586729503096420295_n_jthucz.jpg',
      workshop: "Musical Workshop",
      date: "Date: 9th September 2023",
      venue: "Venue:BBA,Nit Rourkela",
    },
  ];
  
  return (
    <div className="music bg-[#CCCCCC]  w-full min-h-screen relative ">
      {/* Category */}
      <div className=" pt-20 lg:pt-32 px-auto lg:pl-10 w-fit h-1/3 relative">
        <img
          src="https://res.cloudinary.com/dkqxnquga/image/upload/v1693719224/Group_8_1_orpa1z.png"
          alt="music"
        ></img>
        <h1 className=" absolute text-outfit text-white text-6xl sm:text-9xl lg:text-[200px] font-black bottom-2 left-[22%] md:left-[25%] lg:left-28 xl:left-20 tracking-widest">
          MUSIC
        </h1>
      </div>

      {/* Workshop Description */}
      {music.map(({ id, speaker, src, designation, workshop, date, venue }) => (
        <div
          key={id}
          className="w-full h-1/3 sm:max-w-2xl lg:max-w-xl xl:max-w-3xl  flex flex-col md:flex-row items-center justify-start text-outfit my-10 mx-auto xl:ml-10 "
        >
          <div
            className={`w-40 h-40 md:w-64 md:h-64 xl:w-80 xl:h-80  bg-no-repeat bg-cover bg-center rounded-full border-8 border-[#B3B3B3]  hover:scale-110 duration-150`}
          >
            <img src={src} alt="music" className="w-full h-full rounded-full" />
          </div>

          <div className="text-center md:text-left text-white h-2/3  mt-6 md:ml-10 ">
            <h className="text-3xl md:text-6xl lg:text-4xl font-extrabold ">
              {speaker}
            </h>
            <h1 className="text-2xl md:text-5xl  lg:text-3xl font-bold ">
              {designation}
            </h1>
            <br />
            <div className="text-md md:text-2xl lg:text-xl font-semibold leading-none">
              <h1>{workshop}</h1>
              <h1>{date}</h1>
              <h1>{venue}</h1>
            </div>
          </div>
        </div>
      ))}

      {/* Category Image*/}
      <div className=" sm:ml-[10%]  lg:ml-[18%] xl:absolute xl:bottom-2 xl:right-0 ">
        <img
          src="https://res.cloudinary.com/dkqxnquga/image/upload/v1693933262/image_htkrlm.png"
          alt="music"
        ></img>
      </div>
    </div>
  );
}

export default Music;
